module.exports = __webpack_public_path__ + "img/algorithms.82d6d7db.svg";